import React from "react";
import ButtonInput from "../../../../components/common/Button/ButtonInput";
import CustomTable from "../../../../components/common/Table/CustomTable";
import TextInput from "../../../../components/common/TextInput/TextInput";
import { renderCapitalOutletColumns } from "../constants";

const CapitalOutlet = ({
  handleEditButtonClick,
  data,
  loading,
  handleTableChange,
  tablePagination,
  handleEnter,
  handleOutletButtonClick,
  pageSizeValue,
  handleInputChange,
}) => {
  return (
    <div className="py-3">
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={"7%"}
          handleEnter={handleEnter}
          value={pageSizeValue}
          handleChange={handleInputChange}
        />
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Nama Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
      </div>

      <CustomTable
        columns={renderCapitalOutletColumns(handleEditButtonClick)}
        data={data}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />
    </div>
  );
};

export default CapitalOutlet;
